import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { TQueryOptions } from 'common/models'
import { IResponseUserLanguage, IUserLanguage } from 'user/models'

import { ApiKeysEnum } from './apiKeys'

const getLanguages = async () => {
  const { data } = await axios.get<IResponseUserLanguage>(
    'https://xeltotranslations.blob.core.windows.net/platform/lang.json',
    {
      params: {
        v: new Date().getTime(),
      },
    },
  )

  return data?.langs ?? []
}

export default function useGetLanguagesQuery(
  options: TQueryOptions<IUserLanguage[]> = {},
) {
  return useQuery({
    queryKey: [ApiKeysEnum.GET_LANGUAGES],
    queryFn: getLanguages,
    ...options,
  })
}
